(function (app, core, common) {
    'use strict';

    const TEMPLATES = {
        FIXTURES_EVENT: 'fixtures.fixture-timeline-event',
        FIXTURES_SUB:'fixtures.fixture-modal-sub',
        FIXTURES_CARD: 'fixtures.fixture-modal-card',
        FIXTURES_SCORING: 'fixtures.fixture-modal-scoring',
        FIXTURES_SCORER: 'fixtures.fixture-modal-scorer',
        FIXTURES_SCORE: 'fixtures.fixture-score'
    };

    const MILLISECONDS = {
        FIVE_SECONDS: 5000,
        FOUR_SECONDS: 4000,
        TWO_SECONDS: 2000
    };

    app.MatchPolling = function ( match, summaryRes, timelineRes, events, isKnockouts=false ) {
        const _self = this;

        _self.fixtureModal = document.querySelector('.js-fixture-modal');
        _self.parentClass = isKnockouts ? 'knockout-list' : 'fixture-list';
        _self.tape = '';
        _self.events = events;

        const modalContainer = _self.fixtureModal.querySelector( '.js-fixture-modal-container' );
        if ( modalContainer && modalContainer.dataset.matchId && modalContainer.dataset.matchId === match.matchId ) {

            const model = {
                scoreA: match.scores[0] || '0',
                scoreB: match.scores[1] || '0',
                status: match.status,
                parentClass: _self.parentClass
            }

            const modalScores = _self.fixtureModal.querySelector( '.js-scores' );
            if ( modalScores ) {
                if ( model ) {
                    modalScores.innerHTML = app.templating.render( model, TEMPLATES.FIXTURES_SCORE );
                    common.updateStatus( modalContainer, match, modalScores, true );
                }
            }

            _self.updateModalEvents( summaryRes, timelineRes );

            return _self.events;
        }
    }

    app.MatchPolling.prototype.updateModalEvents = function ( summaryRes, timelineRes ) {
        const _self = this;

        _self.updateLineUps( summaryRes.teams, timelineRes.timeline );
        _self.updateHalfTimeScore( timelineRes.timeline, summaryRes.match.status );
        _self.updateTimeline( summaryRes, timelineRes );
    }

    app.MatchPolling.prototype.updateLineUps = function ( teams, timeline ) {
        const _self = this;

        _self.lineups = document.querySelector( '.js-lineup' );
        _self.summary = document.querySelector( '.js-fixture-summary' );
        _self.teams = teams;
        let displayedAlready = false;

        timeline.forEach( event => {
            if ( event.type === "Sub On" || event.type === "Sub Off" ) {
                displayedAlready = _self.events.renderedSubs.find( millis => millis === event.timestamp.millis );
                if ( !displayedAlready ) {
                    _self.addSub( event );
                }
            }
        } );

        teams.forEach( ( team, idx ) => {
            const yellows = team.disciplinary.YC || [];
            yellows.forEach( yellowCard => {
                displayedAlready = _self.events.renderedCards.find( millis => millis === yellowCard.timestamp.millis );
                if ( !displayedAlready ) {
                    _self.addCard( yellowCard, idx );
                }
            } );
            const reds = team.disciplinary.RC || [];
            reds.forEach( redCard => {
                displayedAlready = _self.events.renderedCards.find( millis => millis === redCard.timestamp.millis );
                if ( !displayedAlready ) {
                    _self.addCard( redCard, idx );
                }
            } );
            const cons = team.scoring.Con || [];
            cons.forEach( con => {
                displayedAlready = _self.events.renderedScoring.find( millis => millis === con.timestamp.millis );
                if ( !displayedAlready ) {
                    _self.addScoring( con, idx );
                }
            } );
            const pens = team.scoring.Pen || [];
            pens.forEach( pen => {
                displayedAlready = _self.events.renderedScoring.find( millis => millis === pen.timestamp.millis );
                if ( !displayedAlready ) {
                    _self.addScoring( pen, idx );
                }
            } );
            const tries = team.scoring.Try || [];
            tries.forEach( rugbyTry => {
                displayedAlready = _self.events.renderedScoring.find( millis => millis === rugbyTry.timestamp.millis );
                if ( !displayedAlready ) {
                    _self.addScoring( rugbyTry, idx );
                }
            } );
            const dropGoals = team.scoring.dropGoals || [];
            dropGoals.forEach( dropGoal => {
                displayedAlready = _self.events.renderedScoring.find( millis => millis === dropGoal.timestamp.millis );
                if ( !displayedAlready ) {
                    _self.addScoring( dropGoal, idx );
                }
            } );
        } );
    }

    app.MatchPolling.prototype.updateHalfTimeScore = function ( timeline, status ) {

        const halfTimeScoreContainer = document.querySelector('.js-ht-scores');
        const halfTimeScoreValue = document.querySelector('.js-ht-scores-value');
        const getHalfTimeScores = common.getHalfTimeScores( timeline, status );

        if ( getHalfTimeScores ) {
            halfTimeScoreContainer.classList.remove('u-hide');
            halfTimeScoreValue.innerHTML = getHalfTimeScores;
        } else {
            halfTimeScoreContainer.classList.add('u-hide');
        }
    }

    app.MatchPolling.prototype.updateTimeline = function ( summaryRes, timelineRes ) {
        const _self = this;

        let sortedTimeline = timelineRes.timeline;
        sortedTimeline = timelineRes.timeline.sort( ( a, b ) => {
            if ( a.time.secs < b.time.secs ) {
                return -1;
            }
            if ( a.time.secs > b.time.secs ) {
                return 1;
            }
            return 0;
        });

        let displayedAlready = false;
        if ( sortedTimeline ) {
            const timeline = document.querySelector('.js-timeline');
            const pollingEvents = document.querySelector('.js-polling-events');
            if ( timeline && pollingEvents ) {

                let i = 0;
                sortedTimeline.forEach( event => {

                    displayedAlready = _self.events.renderedEvents.find( millis => millis === event.timestamp.millis );
                    if ( !displayedAlready ) {

                        _self.checkTickerTape( event );

                        const model = {
                            event: event,
                            teams: summaryRes.teams,
                            eventCode: _self.eventCode,
                            renderItem: true,
                            kotape: _self.tape === 'koTape',
                            httape: _self.tape === 'htTape',
                            fttape: _self.tape === 'ftTape'
                        }

                        if ( pollingEvents ) {
                            setTimeout( () => {
                                pollingEvents.innerHTML += app.templating.render( model, TEMPLATES.FIXTURES_EVENT );
                            }, MILLISECONDS.TWO_SECONDS + ( MILLISECONDS.FOUR_SECONDS * i ) );

                            setTimeout( () => {
                                const newEvent = pollingEvents.querySelector( '.js-new-event' );
                                if ( newEvent ) {
                                    core.style.removeClass( newEvent, 'js-new-event' );
                                    core.style.addClass( newEvent, 'no-animation' );
                                }
                            }, MILLISECONDS.FIVE_SECONDS + ( MILLISECONDS.FOUR_SECONDS * i ) );
                            _self.events.renderedEvents.push( event.timestamp.millis );
                            _self.lastRenderedEvent = event.phase;
                            i++;
                        }
                    }
                });
            }
        }
    }

    app.MatchPolling.prototype.addSub = function ( event ) {
        const _self = this;

        const subTime = event.time.secs || 0;
        const players = _self.lineups ? _self.lineups.querySelectorAll( '.js-player' ) : [];

        const model = {
            sub: event.type && event.type === "Sub On" ? "isSubbedOn" : "isSubbedOff",
            millis: event.timestamp.millis || '',
            time: Math.ceil( subTime / 60 )
        }

        players.forEach( player => {
            if ( player.dataset.playerId && event.playerId && player.dataset.playerId === event.playerId ) {
                const scoringContainer = player.querySelector( '.js-scoring-container' );
                if ( scoringContainer ) {
                    scoringContainer.innerHTML += app.templating.render( model, TEMPLATES.FIXTURES_SUB );
                }
            }
        });
        _self.events.renderedSubs.push( event.timestamp.millis );
    }

    app.MatchPolling.prototype.addCard = function ( card, idx ) {
        const _self = this;

        const players = _self.lineups ? _self.lineups.querySelectorAll( '.js-player' ) : [];
        const cssClass = card.type && card.type === "Yellow" ? "yellow-card" : "red-card";

        const model = {
            card: cssClass,
            millis: card.timestamp.millis || ''
        }

        players.forEach( player => {
            if ( player.dataset.playerId && card.playerId && player.dataset.playerId === card.playerId ) {
                const scoringContainer = player.querySelector( '.js-scoring-container' );
                if ( scoringContainer ) {
                    scoringContainer.innerHTML += app.templating.render( model, TEMPLATES.FIXTURES_CARD );
                }
            }
        });

        const cardsContainer = _self.summary.querySelector( '.js-cards' );
        if ( cardsContainer ) {
            const teamCards = cardsContainer.querySelector( `.js-team-${ idx }` );
            if ( teamCards ) {
                teamCards.innerHTML += `<span class="${ cssClass }"></span>`;
                if ( !core.style.hasClass( cardsContainer, 'full-height') ) {
                    core.style.addClass( cardsContainer, 'full-height')
                }
            }
            _self.events.renderedCards.push( card.timestamp.millis );
        }
    }

    app.MatchPolling.prototype.addScoring = function ( scoring, idx ) {
        const _self = this;

        let type = '';
        type = scoring.type && scoring.type === 'C2' ? 'conversion' : type;
        type = scoring.type && scoring.type === 'T5' ? 'tries' : type;

        if ( type ) {
            const players = _self.lineups ? _self.lineups.querySelectorAll( '.js-player' ) : [];

            const model = {
                score: type,
                millis: scoring.timestamp.millis || ''
            }

            players.forEach( player => {
                if ( player.dataset.playerId && scoring.playerId && player.dataset.playerId === scoring.playerId ) {
                    const scoringContainer = player.querySelector( '.js-scoring-container' );
                    if ( scoringContainer ) {
                        scoringContainer.innerHTML += app.templating.render( model, TEMPLATES.FIXTURES_SCORING );
                    }
                }
            });
        }

        type = scoring.type === 'P3' ? 'penalties' : type;
        type = scoring.type === 'D3' ? 'drop-goals' : type;
        const typeContainer = _self.summary.querySelector( `.js-${ type }` );
        let teamContainers = [];
        if ( typeContainer ) {
            teamContainers = typeContainer.querySelectorAll( `.js-team-${ idx }` );
        }

        let alreadyScored = false;
        if ( teamContainers ) {
            teamContainers.forEach( teamContainer => {
                let existingScorers = teamContainer ? teamContainer.querySelectorAll( '.js-scorer' ) : [];

                existingScorers.forEach( existingScorer => {
                    if ( existingScorer && existingScorer.dataset.playerId === scoring.playerId ) {
                        const minute = existingScorer.querySelector( '.js-minute' );
                        if ( minute ) {
                            minute.innerHTML += "," + Math.ceil( scoring.time.secs / 60 ) + "'";
                            alreadyScored = true;
                        }
                    }
                } )
            } )
        }

        let playerName = '';
        const squadPlayers = _self.teams[ idx ].teamList.list || [];

        squadPlayers.forEach( player => {
            if ( player.player.id && scoring.playerId && player.player.id === scoring.playerId ) {
                playerName = player.player.name.display || '';
            }
        } )

        const teamTypeContainer = typeContainer.querySelector( `.js-team-${ idx }-container` );
        let existingTeamContainer = '';
        if ( teamTypeContainer ) {
            existingTeamContainer = teamTypeContainer.querySelector( `.js-team-${ idx }` );
        }
        let firstOfType = existingTeamContainer ? false : true;

        if ( !alreadyScored ) {
            const model = {
                playerId: scoring.playerId,
                playerName: playerName,
                minute: Math.ceil( scoring.time.secs / 60 ),
                teamIndex: idx,
                firstOfType: firstOfType
            }

            if ( firstOfType && teamTypeContainer ) {
                teamTypeContainer.innerHTML += app.templating.render( model, TEMPLATES.FIXTURES_SCORER );
                if ( !core.style.hasClass( teamTypeContainer.parentElement, 'full-height' ) ) {
                    core.style.addClass( teamTypeContainer.parentElement, 'full-height' )
                }
            } else {
                existingTeamContainer.innerHTML += app.templating.render( model, TEMPLATES.FIXTURES_SCORER );
            }
        }

        _self.events.renderedScoring.push( scoring.timestamp.millis );
    }

    app.MatchPolling.prototype.checkTickerTape = function ( event ) {
        const _self = this;

        const isOvertime = event.phase === 'L3' || event.phase === 'L4';
        if ( event.phase ) {
            if ( event.phase && _self.events.renderedEvents.length === 0 && !_self.events.renderedKoTape ) {
                _self.tape = 'koTape';
                _self.events.renderedKoTape = true;
            } else if ( event.phase && _self.lastRenderedEvent === 'L1' && event.phase === 'L2' && !_self.events.renderedHtTape ) {
                _self.tape = 'htTape';
                _self.events.renderedHtTape = true;
            } else if ( event.phase && _self.lastRenderedEvent === 'L2' && isOvertime && !_self.events.renderedFtTape ) {
                _self.tape = 'ftTape';
                _self.events.renderedFtTape = true;
            } else {
                _self.tape = '';
            }
        }
    }

})(PULSE.app, PULSE.core, PULSE.app.common);